document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('[js-marketing-materials="form"]');
	if (!form) return;

	const submitBtn = form.querySelector('[js-marketing-materials="add-to-cart"]');
	const countEl = form.querySelector('[js-marketing-materials="count"]');
	const errorEl = form.querySelector('[js-marketing-materials="error"]');
	const otherRole = `${window.FoxThemeStrings.otherOption}`;
	const roleSelect = form.querySelector('[js-marketing-materials="medical-role"]');
	const jobField = form.querySelector('[js-marketing-materials="medical-job-field"]');
	const jobInput = form.querySelector('[js-marketing-materials="medical-job-title"]');
	const isOtherSelected = () => (roleSelect?.value || '').trim() === otherRole;
	const closeBtn = document.querySelector('[js-marketing-materials="close"]');
	const getErrorEl = (key) => form.querySelector(`[js-mm-error-for="${key}"]`);

	const clearModalForm = () => {
		const hospitalInput = form.querySelector('[js-marketing-materials="hospital-name"]');
		const patientsInput = form.querySelector('[js-marketing-materials="patients"]');
		const jobInput = form.querySelector('[js-marketing-materials="medical-job-title"]');

		if (hospitalInput) hospitalInput.value = '';
		if (patientsInput) patientsInput.value = '';
		if (jobInput) jobInput.value = '';

		const roleSelect = form.querySelector('[js-marketing-materials="medical-role"]');
		if (roleSelect) {
			roleSelect.selectedIndex = 0;
			roleSelect.dispatchEvent(new Event('change', { bubbles: true }));
		}

		const jobField = form.querySelector('[js-marketing-materials="medical-job-field"]');
		if (jobField) jobField.classList.add('hidden');
		if (jobInput) jobInput.required = false;

		form.querySelectorAll('[js-marketing-materials="checkbox"]').forEach((cb) => {
			cb.checked = false;
			const row = cb.closest('[js-marketing-materials="item"]');
			if (row) row.classList.remove('is-active');
		});

		updateSelectedCountText();
		clearError();
		clearAllFieldErrors();
	};

	/**
	 * Close modal event.
	 */
	closeBtn?.addEventListener('click', () => {
		clearModalForm();
	});

	/**
	 * Sync medical role.
	 */
	const syncMedicalRoleUI = () => {
		if (!jobField || !jobInput || !roleSelect) return;

		const show = isOtherSelected();
		jobField.classList.toggle('hidden', !show);
		jobInput.required = show;

		if (!show) jobInput.value = '';
	};

	syncMedicalRoleUI();
	roleSelect?.addEventListener('change', () => {
		syncMedicalRoleUI();
		clearError();
	});

	/**
	 * Show error message.
	 * @param show
	 */
	const showError = (show = true) => {
		if (!errorEl) return;
		errorEl.classList.toggle('hidden', !show);

		if (show) {
			errorEl.setAttribute('role', 'alert');
			errorEl.setAttribute('aria-live', 'polite');
			errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	};

	const clearError = () => showError(false);

	const setLoading = (isLoading) => {
		if (!submitBtn) return;
		submitBtn.disabled = isLoading;
		submitBtn.setAttribute('aria-busy', String(isLoading));
	};

	const pickValue = (selector) => {
		const el = form.querySelector(selector);
		return el ? String(el.value || '').trim() : '';
	};

	/**
	 * Helper to check pick value.
	 * @param val {String} - Value of the form fields.
	 * @returns {boolean}
	 */
	const isEmpty = (val) => !val || !String(val).trim();

	/**
	 * Add active class to the selected item.
	 * @param checkbox {Object} - Checkbox object.
	 */
	const syncRowActiveState = (checkbox) => {
		const row = checkbox.closest('[js-marketing-materials="item"]');
		if (!row) return;
		row.classList.toggle('is-active', checkbox.checked);
	};

	/**
	 * Format text for count string.
	 * @param template {String} - Text string.
	 * @param count {Number} - Count number of selected item(s).
	 * @returns {string}
	 */
	const formatCountText = (template, count) => {
		if (!template) return '';
		return String(template).replace(/\{\{\s*count\s*\}\}/g, String(count));
	};

	/**
	 * Get count of selected item(s).
	 * @returns {number}
	 */
	const getSelectedCount = () => {
		return form.querySelectorAll('[js-marketing-materials="checkbox"]:checked').length;
	};

	/**
	 * Update selected count text label.
	 */
	const updateSelectedCountText = () => {
		if (!countEl) return;

		const count = getSelectedCount();

		let template = `${FoxThemeStrings.noItemSelected}`;
		if (count === 1) template = `${FoxThemeStrings.itemSelected}`;
		if (count > 1) template = `${FoxThemeStrings.itemsSelected}`;

		countEl.textContent = formatCountText(template, count);
	};

	form.querySelectorAll('[js-marketing-materials="checkbox"]').forEach((cb) => {
		syncRowActiveState(cb);
	});
	updateSelectedCountText();

	form.addEventListener("input", (e) => {
		const key = e.target.getAttribute?.("js-marketing-materials");
		if (!key) return;

		const allowed = ["hospital-name", "medical-role", "medical-job-title", "patients"];
		if (!allowed.includes(key)) return;

		setFieldError(key, "");
		setInvalidUI(`[js-marketing-materials="${key}"]`, false);
	});

	/**
	 * Form change event for item.
	 */
	form.addEventListener("change", (e) => {
		const checkbox = e.target.closest?.('[js-marketing-materials="checkbox"]');
		if (checkbox) {
			syncRowActiveState(checkbox);
			updateSelectedCountText();

			if (getSelectedCount() > 0) setFieldError("products", "");
		}

		clearError();
	});

	const setFieldError = (key, message = "") => {
		const el = getErrorEl(key);
		if (!el) return;

		el.textContent = message;
		el.classList.toggle("hidden", !message);
	};

	const setInvalidUI = (selector, isInvalid) => {
		const field = form.querySelector(selector);
		if (!field) return;
		field.classList.toggle("mm-invalid", Boolean(isInvalid));
	};

	const clearAllFieldErrors = () => {
		["hospital-name", "medical-role", "medical-job-title", "patients", "products"].forEach((k) => {
			setFieldError(k, "");
		});

		setInvalidUI('[js-marketing-materials="hospital-name"]', false);
		setInvalidUI('[js-marketing-materials="medical-role"]', false);
		setInvalidUI('[js-marketing-materials="medical-job-title"]', false);
		setInvalidUI('[js-marketing-materials="patients"]', false);
	};

	/**
	 * Validate form
	 * @returns {boolean}
	 */
	const validateForm = () => {
		clearAllFieldErrors();

		let isValid = true;

		const selectedCount = getSelectedCount();
		const hospitalName = pickValue('[js-marketing-materials="hospital-name"]');
		const medicalRole = pickValue('[js-marketing-materials="medical-role"]');
		const patientsPerMonth = pickValue('[js-marketing-materials="patients"]');
		const jobTitle = pickValue('[js-marketing-materials="medical-job-title"]');
		const mmErrors = window.FoxThemeStrings.MarketingMaterialsErrors || {};

		if (!selectedCount) {
			setFieldError("products", mmErrors.products || "Please select at least one product");
			isValid = false;
		}

		if (isEmpty(hospitalName)) {
			setFieldError("hospital-name", mmErrors.hospitalName || "Hospital name is required");
			setInvalidUI('[js-marketing-materials="hospital-name"]', true);
			isValid = false;
		}

		if (isEmpty(medicalRole)) {
			setFieldError("medical-role", mmErrors.medicalRole || "Please select your role");
			setInvalidUI('[js-marketing-materials="medical-role"]', true);
			isValid = false;
		}

		if (medicalRole === otherRole) {
			if (isEmpty(jobTitle)) {
				setFieldError("medical-job-title", mmErrors.jobTitle || "Please enter your job title");
				setInvalidUI('[js-marketing-materials="medical-job-title"]', true);
				isValid = false;
			}
		}

		if (isEmpty(patientsPerMonth)) {
			setFieldError("patients", mmErrors.patients || "Patients per month is required");
			setInvalidUI('[js-marketing-materials="patients"]', true);
			isValid = false;
		}

		return isValid;
	};

	/**
	 * Submit event.
	 */
	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		clearError();

		if (!validateForm()) {
			const firstError = form.querySelector('.marketing-materials__error:not(.hidden)');
			firstError?.scrollIntoView({ behavior: "smooth", block: "center" });

			return;
		}

		const items = [];
		const rows = form.querySelectorAll('[js-marketing-materials="item"]');

		rows.forEach((row) => {
			const checkbox = row.querySelector('[js-marketing-materials="checkbox"]');
			if (!checkbox || !checkbox.checked) return;

			const select = row.querySelector('select');
			if (!select) return;

			const option = select.selectedOptions && select.selectedOptions?.[0];
			if (!option) return;

			const isDisabled = option.disabled;
			const isAvailable = option.dataset.available !== 'false';
			if (isDisabled || !isAvailable) return;

			const variantId = Number(option.value);
			const getQtyFromOption = (option) => {
				const text = (option.textContent || option.label || "").trim();
				const match = text.match(/\d+/);
				let qty = match ? parseInt(match[0], 10) : 1;

				if (!Number.isFinite(qty) || qty < 1) qty = 1;
				qty = Math.min(qty, 99);
				return qty;
			};
			const qty = getQtyFromOption(option);

			if (!variantId && !qty) return;

			console.log(option.dataset.qty)
			items.push({
				id: variantId,
				quantity: qty
			});
		});

		const hospitalName = pickValue('[js-marketing-materials="hospital-name"]');
		const medicalRole = pickValue('[js-marketing-materials="medical-role"]');
		const patientsPerMonth = pickValue('[js-marketing-materials="patients"]');
		const jobTitle = pickValue('[js-marketing-materials="medical-job-title"]');

		const attributes = {};
		attributes.marketing_materials = 'true';
		if (hospitalName) attributes.hospital_name = hospitalName;
		if (medicalRole) {
			attributes.medical_role = medicalRole === otherRole ? jobTitle : medicalRole;
		}
		if (patientsPerMonth) attributes.patients_per_month = patientsPerMonth;

		try {
			setLoading(true);

			const addRes = await fetch(`${FoxThemeSettings.routes.cart_add_url}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ items })
			});

			if (!addRes.ok) {
				const err = await addRes.json().catch(() => ({}));
				throw new Error(err?.description || 'Failed to add items to cart.');
			}

			if (Object.keys(attributes).length) {
				const updRes = await fetch(`${window.FoxThemeSettings.routes.cart_update_url}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ attributes })
				});

				if (!updRes.ok) console.warn('Failed to save cart attributes.');
			}

			window.location.href = '/checkout';
		} catch (error) {
			console.error(error);
			alert(error.message || 'Something went wrong. Please try again.');
		} finally {
			setLoading(false);
		}
	});
});
